var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDyscalculia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 60,
    viewBox: "0 0 52 46",
    width: 60,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22.92a2 2 0 012-2h8a2 2 0 012 2v8a2 2 0 01-2 2h-8a2 2 0 01-2-2zm22 7a2 2 0 012-2h7a2 2 0 012 2v7a2 2 0 01-2 2h-7a2 2 0 01-2-2zm-36 0a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H7a2 2 0 01-2-2zm11-27a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2h-6a2 2 0 01-2-2z",
    fill: "#3420ed"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#50b3ec"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 9,
    rx: 0.5,
    width: 9,
    x: 37.5,
    y: 9.419
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5,
    rx: 0.5,
    width: 5,
    x: 33.5,
    y: 21.419
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    rx: 0.5,
    width: 2,
    x: 36.5,
    y: 31.419
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    rx: 0.5,
    width: 2,
    x: 28.5,
    y: 13.419
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 0.5,
    width: 8,
    x: 29.5,
    y: 37.419
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    rx: 0.5,
    width: 3,
    x: 16.5,
    y: 40.419
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    rx: 0.5,
    width: 2,
    x: 13.5,
    y: 23.419
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5,
    rx: 0.5,
    width: 5,
    x: 12.5,
    y: 13.419
  }), /*#__PURE__*/React.createElement("rect", {
    height: 7,
    rx: 0.5,
    width: 7,
    x: 0.5,
    y: 17.419
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5.92a1 1 0 011-1h3a1 1 0 110 2h-3a1 1 0 01-1-1m25 29a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1m0-3a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1m-21.5-5a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1M7.879 30.798a1 1 0 011.414 0l2.829 2.828a1 1 0 01-1.415 1.415L7.88 32.212a1 1 0 010-1.414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 23.92a1 1 0 011 1v4a1 1 0 11-2 0v-4a1 1 0 011-1m-12.879 6.878a1 1 0 010 1.414l-2.828 2.829a1 1 0 01-1.415-1.415l2.829-2.828a1 1 0 011.414 0"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjYwIiB2aWV3Qm94PSIwIDAgNTIgNDYiIHdpZHRoPSI2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMTkgMjIuOTJhMiAyIDAgMCAxIDItMmg4YTIgMiAwIDAgMSAyIDJ2OGEyIDIgMCAwIDEgLTIgMmgtOGEyIDIgMCAwIDEgLTItMnptMjIgN2EyIDIgMCAwIDEgMi0yaDdhMiAyIDAgMCAxIDIgMnY3YTIgMiAwIDAgMSAtMiAyaC03YTIgMiAwIDAgMSAtMi0yem0tMzYgMGEyIDIgMCAwIDEgMi0yaDZhMiAyIDAgMCAxIDIgMnY2YTIgMiAwIDAgMSAtMiAyaC02YTIgMiAwIDAgMSAtMi0yem0xMS0yN2EyIDIgMCAwIDEgMi0yaDZhMiAyIDAgMCAxIDIgMnY2YTIgMiAwIDAgMSAtMiAyaC02YTIgMiAwIDAgMSAtMi0yeiIgZmlsbD0iIzM0MjBlZCIvPjxnIHN0cm9rZT0iIzUwYjNlYyI+PHJlY3QgaGVpZ2h0PSI5IiByeD0iLjUiIHdpZHRoPSI5IiB4PSIzNy41IiB5PSI5LjQxOSIvPjxyZWN0IGhlaWdodD0iNSIgcng9Ii41IiB3aWR0aD0iNSIgeD0iMzMuNSIgeT0iMjEuNDE5Ii8+PHJlY3QgaGVpZ2h0PSIyIiByeD0iLjUiIHdpZHRoPSIyIiB4PSIzNi41IiB5PSIzMS40MTkiLz48cmVjdCBoZWlnaHQ9IjIiIHJ4PSIuNSIgd2lkdGg9IjIiIHg9IjI4LjUiIHk9IjEzLjQxOSIvPjxyZWN0IGhlaWdodD0iOCIgcng9Ii41IiB3aWR0aD0iOCIgeD0iMjkuNSIgeT0iMzcuNDE5Ii8+PHJlY3QgaGVpZ2h0PSIzIiByeD0iLjUiIHdpZHRoPSIzIiB4PSIxNi41IiB5PSI0MC40MTkiLz48cmVjdCBoZWlnaHQ9IjIiIHJ4PSIuNSIgd2lkdGg9IjIiIHg9IjEzLjUiIHk9IjIzLjQxOSIvPjxyZWN0IGhlaWdodD0iNSIgcng9Ii41IiB3aWR0aD0iNSIgeD0iMTIuNSIgeT0iMTMuNDE5Ii8+PHJlY3QgaGVpZ2h0PSI3IiByeD0iLjUiIHdpZHRoPSI3IiB4PSIuNSIgeT0iMTcuNDE5Ii8+PC9nPjxnIGZpbGw9IiNmZmYiPjxwYXRoIGQ9Im0xOC41IDUuOTJhMSAxIDAgMCAxIDEtMWgzYTEgMSAwIDEgMSAwIDJoLTNhMSAxIDAgMCAxIC0xLTFtMjUgMjlhMSAxIDAgMCAxIDEtMWg0YTEgMSAwIDEgMSAwIDJoLTRhMSAxIDAgMCAxIC0xLTFtMC0zYTEgMSAwIDAgMSAxLTFoNGExIDEgMCAxIDEgMCAyaC00YTEgMSAwIDAgMSAtMS0xbS0yMS41LTVhMSAxIDAgMCAxIDEtMWg0YTEgMSAwIDEgMSAwIDJoLTRhMSAxIDAgMCAxIC0xLTFtLTE0LjEyMSAzLjg3OGExIDEgMCAwIDEgMS40MTQgMGwyLjgyOSAyLjgyOGExIDEgMCAwIDEgLTEuNDE1IDEuNDE1bC0yLjgyNy0yLjgyOWExIDEgMCAwIDEgMC0xLjQxNCIvPjxwYXRoIGQ9Im0yNSAyMy45MmExIDEgMCAwIDEgMSAxdjRhMSAxIDAgMSAxIC0yIDB2LTRhMSAxIDAgMCAxIDEtMW0tMTIuODc5IDYuODc4YTEgMSAwIDAgMSAwIDEuNDE0bC0yLjgyOCAyLjgyOWExIDEgMCAwIDEgLTEuNDE1LTEuNDE1bDIuODI5LTIuODI4YTEgMSAwIDAgMSAxLjQxNCAwIi8+PC9nPjwvc3ZnPg==";
export { SvgDyscalculia as ReactComponent };